module.exports = __webpack_public_path__ + "static/media/SFMono-RegularItalic.bb1fc3ab.woff2";